export default __webpack_public_path__ + "static/media/download-googleplay-it.0ddded8f.png";